// @flow
import * as React from 'react';
import { Stack } from '@mui/material';
import { NextActionCard, NoData } from '../../../../shared';
import { useClientNextActions } from '../../hooks/use-client-next-actions';
import { useClient } from '../../hooks/client-context';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import _ from 'lodash';

export const NextActionsOverview = () => {
  const client = useClient();
  const nextActions = useClientNextActions(client.id)

  const height = nextActions.length * 90 > 400 ? 400 : nextActions.length * 90

  return (
    <Stack flex={1}>
      {!nextActions.length && <NoData>No next actions</NoData>}
      <OverlayScrollbarsComponent
        style={{height, paddingRight: nextActions.length > 4 ? 16 : 0}}
        options={{ paddingAbsolute: true }}
        defer
      >
        <Stack gap={2} flex={1}>
          {_.orderBy(nextActions.filter(a => !a.done), 'dueDate', 'asc').map((action, index) => (
            <NextActionCard item={action} key={index} />
          ))}
        </Stack>
      </OverlayScrollbarsComponent>
    </Stack>
  );
};
